import { EntityIdAliasPrefixes } from '@abb-procure/constants';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class EntityService {
  private type: EntityIdAliasPrefixes = EntityIdAliasPrefixes.Project;
  private entityId: string = '';

  getEntityType(): EntityIdAliasPrefixes {
    return this.type;
  }

  getEntityTypeLabel(): string {
    switch (this.type) {
      case EntityIdAliasPrefixes.Project:
        return 'Project';
      case EntityIdAliasPrefixes.RfRFQ:
        return 'RFRFQ';
      case EntityIdAliasPrefixes.Rfq:
        return 'RFQ';
      case EntityIdAliasPrefixes.Supplier:
        return 'Supplier';
      case EntityIdAliasPrefixes.PriceEntry:
        return 'Price Entry';
      case EntityIdAliasPrefixes.Quotation:
        return 'Quotation';
      case EntityIdAliasPrefixes.TemplateRfrfq:
        return 'Template RFRFQ';
      case EntityIdAliasPrefixes.TemplateProject:
        return 'Template Project';
      case EntityIdAliasPrefixes.TemplateSPE:
        return 'Template SPE';
      case EntityIdAliasPrefixes.GeneralTSPE:
        return 'General Template SPE';
      case EntityIdAliasPrefixes.Survey:
        return 'Survey';
      case EntityIdAliasPrefixes.SupplierEvaluation:
        return 'Supplier Evaluation';
      case EntityIdAliasPrefixes.DivisionSupplierEvaluationSupplierCriteria:
        return 'Division Supplier Evaluation Criteria';
      case EntityIdAliasPrefixes.Category:
        return 'Category';
      case EntityIdAliasPrefixes.Strategy:
        return 'Strategy';
      case EntityIdAliasPrefixes.Agent:
        return 'Agent';
      default:
        return '';
    }
  }

  getEntityId(): string {
    return this.entityId;
  }

  getEntityNumber(): string {
    if (!this.type || !this.entityId) {
      return '';
    }

    return `${this.type}-${this.entityId}`;
  }

  hasRevision(route: ActivatedRoute): boolean {
    const { queryParamMap } = route.snapshot;

    return !!queryParamMap.get('revision');
  }

  checkRouteData(route: ActivatedRoute): void {
    this.getTypeByRoute(route);
    this.getIdByRoute(route);
  }

  private getTypeByRoute(route: ActivatedRoute): void {
    const { entityType } = route.snapshot.data;

    this.type = entityType as EntityIdAliasPrefixes;
  }

  private getIdByRoute(route: ActivatedRoute): void {
    const { params } = route.snapshot;

    this.entityId = params.entityId;
  }
}
